import { Validation } from '@agilelab/plugin-wb-governance-common';
import {
  TableCellProps,
  WbStatusBadge,
  WbTruncatedTypographyWrapper,
  getTruncateMaxLinesStyle,
} from '@agilelab/plugin-wb-platform';
import { useMemo } from 'react';
import { Issues } from '../Components/Issues';
import { ValidationTitle } from '../Components/ValidationTitle';

const STATUS_WIDTH = 60;

export const useColumns = () => {
  return useMemo<TableCellProps<Validation>[]>(
    () => [
      {
        field: 'name',
        headerName: 'Section',
        fieldRender: (row, { rowDepth }) => {
          const isRoot = rowDepth === 0;
          return (
            <ValidationTitle important={isRoot} name={row.name ?? row.key} />
          );
        },
      },
      {
        field: 'description',
        headerName: 'Description',
        tooltip: true,
        typographyProps: {
          variant: 'body2',
          style: getTruncateMaxLinesStyle(2, false),
        },
        fieldRender: row => {
          return <WbTruncatedTypographyWrapper value={row.description || ''} />;
        },
      },
      {
        field: 'issues',
        headerName: 'Issues',
        fieldRender: r => {
          return <Issues issues={r.issues} />;
        },
      },
      {
        field: 'compliant',
        headerName: 'Status',
        cellProps: { align: 'center', width: `${STATUS_WIDTH}px` },
        fieldRender: r => <WbStatusBadge ok={r.compliant ?? true} />,
      },
    ],
    [],
  );
};
